import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');

	

const Renderwatchitem = () => {

const resturl=sessionStorage.getItem("RESTURL");
let customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const [modal, setModal] = useState({open:false});
const navWpform = React.useRef();




const [tblblinfo, setTblblinfo] = useState([]);
const [tblwatchitem, setTblwatchitem] = useState([]);
const [arraywatchitem, setArraywatchitem] = useState([]);

const [watchitem, setWatchitem] = useState({
	WATCH_ITEM_ID: ""
	, FIRST_NAME: ""
	,LAST_NAME: ""
	,DOB: ""
	,GENDER: ""
	, NOTE: ""
	,LBR_CLR_APP_ID:""
	, ACTIVE: 1
});



const [dowait, setDowait] = useState({on:false});

const [searchcrit, setSearchcrit] = useState({
	txt:''
	, crit:''
	, active:''
	, userlocation: ''
	, blnum: ''
	});



const location = useLocation();


useEffect(() => {

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if

document.title =   "Watch List";	

if (tblwatchitem.length<1){
	gettblwatchitem();
	}//end if
	//qrylabor();
 },[]);

useEffect(() => {
	document.getElementsByName('txt')[0].focus();
	
 },[JSON.stringify(tblwatchitem)]);



 

useEffect(() => {
		gettblwatchitem();
 },[searchcrit]);


useEffect(() => {
	 
	 //console.log("tblwatchitem: "+JSON.stringify(tblwatchitem));
		
	
 },[JSON.stringify(tblwatchitem)]);

 
useEffect(() => {
	 
	 if (arraywatchitem.length>0)
		writetblwatchitem();
	else
		setTblwatchitem([]);
	
 },[JSON.stringify(arraywatchitem)]);
 
 
async function getwatchitem(e, WATCH_ITEM_ID){
	
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {WATCH_ITEM_ID:WATCH_ITEM_ID} )
  };		

  await fetch(resturl+'rarwpform/getwatchitem',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwatchitem(res) )
      .catch(err => console.log(err));	
	
}//end func


async function aftergetwatchitem(res){
}//end func	
	



function toggleModalsm() {
if (!document.querySelector(".modalsm"))
	return false;


	
const modalsm = document.querySelector(".modalsm");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");
const isopen=modalsm.classList.contains("show-modalsm");
setModal((prev)=>{return {...prev, open:isopen};})

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func



function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");

if (event.target === modalsm) 
	toggleModalsm();
    
}//end func


async function lookupblnum(e){
e.preventDefault();
console.log("lookupblnum: ");

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {blnum: searchcrit.blnum} )
  };		
setTblblinfo([]);
  await fetch(customspremurl+'rarprfc/lookupblnum',requestOptions)
      .then(res => res.json())
      .then(res => 	afterlookupblnum(res) )
      .catch(err => console.log(err));

}//end func


function afterlookupblnum(res){

if (!res.length){
	console.log("abort afterlookupblnum: "+!res.length);
	}
	
let htmrows=[];

res.map((col, index) => {
	const USERNAME=col['USERNAME'];
	const trkey='tr_'+index;
	
	const htmrow=<tr key={trkey} >
	<td align='right' >{index+1}</td>
	<td align='left' >{col['TAX_PAYER_NAME']}</td>
	<td align='left' >{col['TP_TYPE']}</td>
	<td align='left' >{col['NAT_CARD_ID']}</td>
	<td align='left' >{col['DRIVER_LICENSE_NO']}</td>
	<td align='left' >{col['SOCIAL_SEC_NO']}</td>
	<td align='left' >{col['RESIDENT_ADDRESS']}</td>
	<td align='left' >{col['E_MAIL_ADDRESS']}</td>
	</tr>;
	htmrows.push(htmrow);


});

setTblblinfo(htmrows);	
	
}//end func

async function gettblwatchitem(){

let params = searchcrit;
params.USERNAME=sessionStorage.getItem("USERNAME")

console.log("gettblwatchitem: "+JSON.stringify(params));

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
setTblwatchitem([]);
  await fetch(resturl+'rarwpform/tblwatchitem',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblwatchitem(res) )
      .catch(err => console.log(err));

}//end func

function aftergettblwatchitem(res){
	
	
if (!res.length){
	console.log("abort aftergettblwatchitem for !res.length)")
	return;
	}
	
console.log('aftergettblwatchitem, res.length: '+res.length);

let arrtemp=[];

res.map((col, index) => {
	let datas={};
	for(var attributename in col){
			const data=col[attributename];
			//console.log('attributename, data: '+attributename+", "+data);
			datas[attributename] = (data==null)?'':data;
		}//end for	

	arrtemp.push(datas);

});
//console.log('arrtemp: '+JSON.stringify(arrtemp));
setArraywatchitem(arrtemp);

/*
setArraywatchitem((prev)=>{
	return {...prev, arrtemp}
	});

*/

}//end func


function writetblwatchitem(){
	//console.log('writetblwatchitem: '+JSON.stringify(arraywatchitem));
let htmrows=[];	
	
	for (var index=0; index<arraywatchitem.length; index++){
		const col=arraywatchitem[index];
		const WATCH_ITEM_ID=col['WATCH_ITEM_ID'];
		const trkey='tr_'+index;
		const rdkey='td_'+index;
		const x=index;
		
		const htmrow=<tr key={trkey} >
		<td align='right' >{1+index}</td>
		<td align='left' ><a href="#" className="nodecor" onClick={(e)=>{openLabrclr(e,col['LBR_CLR_APP_ID']);}}>{col['LBR_CLR_APP_ID']}</a></td>
		<td align='left' >{col['TC_DOB']}</td>
		<td align='left' >{col['GENDER']}</td>
		<td align='left' ><a href="#" className="nodecor" onClick={(e)=>{openwatchitem(e, x, col['WATCH_ITEM_ID']);}}>{col['FIRST_NAME']}</a></td>
		<td align='left' >{col['LAST_NAME']}</td>
		<td align='left' >{col['NOTE']}</td>
		<td align='left' >{col['MPR_NAME']}</td>
		<td align='left' >{col['LBR_CLR_RCP_AMT']}</td>
		<td align='center' >{col['LBR_CLR_APP_DATE']}</td>
		<td align='left' >{col['LBR_CLR_APP_STAT']}</td>
		<td align='left' >{col['WRK_PMT_APP_STAT']}</td>
		<td align='center' >{col['UPDATED']}</td>	
		</tr>;
		htmrows.push(htmrow);
	}//end if

setTblwatchitem(htmrows);

/*
		<td align='left' >{col['WRK_PMT_RCP_AMT']}</td>
		<td align='center' >{col['WRK_PMT_APP_DATE']}</td>

*/
	
}//end func

function openwatchitem(e, i, WATCH_ITEM_ID){
	
	e.preventDefault();
	console.log("openwatchitem i: "+i);
	console.log("openwatchitem: arraywatchitem.length"+arraywatchitem.length);
	//JSON.stringify(arraywatchitem[i])
	if (i>=arraywatchitem.length)
		return;
if (arraywatchitem[i].WATCH_ITEM_ID==WATCH_ITEM_ID){
	const temp=arraywatchitem[i];
	setWatchitem((prev)=>{
		return {
			...prev
			, WATCH_ITEM_ID: temp.WATCH_ITEM_ID
			, FIRST_NAME: temp.FIRST_NAME
			, LAST_NAME: temp.LAST_NAME
			, DOB: temp.DOB
			, GENDER: temp.GENDER
			, NOTE: temp.NOTE
			, LBR_CLR_APP_ID: temp.LBR_CLR_APP_ID
			}
		});
	}//end if
	toggleModalsm();
	document.getElementsByName("LBR_CLR_APP_ID")[0].readOnly=true;
	if (!document.getElementsByName("LBR_CLR_APP_ID")[0].classList.contains("gnsbro"))
		document.getElementsByName("LBR_CLR_APP_ID")[0].classList.add("gnsbro");
	
}//end func

function openLabrclr(e, LBR_CLR_APP_ID){
	e.preventDefault();
navigate("/lbr_clr_app", {state:{IPM_LBR_CLR_APP_ID:LBR_CLR_APP_ID, BACK_PAGE:"watchlist"}});
}//end func

function promptAddNewperson(e){
	e.preventDefault();
	
	setWatchitem((prev)=>{
		return {
			...prev
		, FIRST_NAME: ""
		, LAST_NAME: ""
		, GENDER: ""
		, DOB: ""
		, NOTE: ""
		, LBR_CLR_APP_ID: ""
		, WATCH_ITEM_ID: ""
		}
		});
	
	
	toggleModalsm();
	document.getElementsByName("LBR_CLR_APP_ID")[0].readOnly=false;
	if (document.getElementsByName("LBR_CLR_APP_ID")[0].classList.contains("gnsbro"))
		document.getElementsByName("LBR_CLR_APP_ID")[0].classList.remove("gnsbro");
	document.getElementsByName("FIRST_NAME")[0].focus();
}//end func


function searchcritChange(e){
	
	let {name, value}=e.target;
	
	if (name=='active')
		value=e.target.checked?1:0;
	
console.log("searchcritChange name: "+name+' '+value);

	setSearchcrit((prev)=>{
		return {...prev, [name]:value}	
	});
	
	//setSearchcrit({name:e.target.name, txt:e.target.value});
}//end func

async function getwatchitemlbrclr(e){
e.target.select();

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {LBR_CLR_APP_ID:e.target.value} )
  };		

  await fetch(resturl+'rarwpform/getwatchitemlbrclr',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwatchitemlbrclr(res) )
      .catch(err => console.log(err));
	  
	  
}//end func


function aftergetwatchitemlbrclr(res){

const GENDER=res.length?(res[0].GENDER??""):"";
if (GENDER=="")
	showsnackbar("no record was found!");
else
	setWatchitem((prev)=>{
		return {
			...prev
		, FIRST_NAME: res[0].FIRST_NAME
		, LAST_NAME: res[0].LAST_NAME
		, GENDER: res[0].GENDER
		, DOB: res[0].DOB
		}
		});
	
}//end func
	
async function submitform1(e){
	e.preventDefault();

if (!document.getElementById("btnsubmit1").classList.contains("hidden"))
	document.getElementById("btnsubmit1").classList.add("hidden");

toggleModalsm();	

let params = watchitem;
params.USERNAME=sessionStorage.getItem("USERNAME");
if (!params.WATCH_ITEM_ID)
	params.WATCH_ITEM_ID=0;

console.log("updatewatchitem: "+JSON.stringify(params));

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
setTblwatchitem([]);
  await fetch(resturl+'rarwpform/updatewatchitem',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdatewatchitem(res) )
      .catch(err => console.log(err));
	
}//end func

async function afterupdatewatchitem(res){

if (document.getElementById("btnsubmit1").classList.contains("hidden"))
	document.getElementById("btnsubmit1").classList.remove("hidden");

	
const NEW_WATCH_ITEM_ID=res.length?(res[0].NEW_WATCH_ITEM_ID??0):0;
const UPDATE_COUNT=res.length?(res[0].UPDATE_COUNT??0):0;

if (NEW_WATCH_ITEM_ID==0 && UPDATE_COUNT==0)
	showsnackbar("that failed.  try again or contact admin");
else{
	showsnackbar("Done!");
	gettblwatchitem();
	}
	
	
}//end func

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func

function handleChange(e){
	const {name, value} = e.target;
	
	setWatchitem((prev)=>{
		return {...prev, [name]:value}
		});
}//end func

  return (
    <>
	
	<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >My Watch List</p>	
	
<table align='center' width="45%" style={{marginTop:"10px", marginBottom:"10px"}} cellSpacing="0" cellPadding="0" >
<tbody>
	<tr>
	<td align='right' >
		<input type='checkbox' id='cbactive' name='active' onClick={(e)=>{searchcritChange(e);}} />
		<label htmlFor='cbactive'  className="hand" >show inactive</label>
		&nbsp;
	</td>
	<td align='right' >search criteria:&nbsp;</td>
	<td align='left' ><input name='txt' defaultValue={searchcrit.txt} onChange={(e)=>{searchcritChange(e);}} onFocus={(e)=>{e.target.select();}} placeholder='name of person' /></td>
	<td align='center' >&nbsp;</td>
	<td align='center' ><a href="#" className="nodecor" onClick={(e)=>{ promptAddNewperson(e); }} ><img src="img/addbutton.png" border="0" /> add new person</a></td>
	</tr>


</tbody>
</table>
	
	<table align='center' className='customers' style={{width:"95%"}} >
	<thead>
	<tr>
		<th>#</th>
		<th>Lc. Id</th>
		<th>DOB</th>
		<th>Gender</th>
		<th>first name</th>
		<th>last name</th>
		<th>Notes</th>
		<th>Employer</th>
		<th>LC Amount</th>
		<th>LC Date</th>
		<th>LC Status</th>
		{/*
		<th>WP Amount</th>
		<th>WP Date</th>
		
		*/}

		<th>WP Status</th>
		<th>Updated</th>

		
	</tr>
	</thead>
	<tbody>
		{tblwatchitem}
	</tbody>
	</table>

<table align='center' width="45%" style={{marginTop:"10px", marginBottom:"10px"}} cellSpacing="0" cellPadding="0" >
<tbody>
	<tr>
	<td align='right' >bl #:&nbsp;</td>
	<td align='left' ><input name='blnum' defaultValue={searchcrit.blnum} onChange={(e)=>{searchcritChange(e);}} onFocus={(e)=>{e.target.select();}} placeholder='bl num e.g. 13136' /></td>
	<td align='center' >&nbsp;</td>
	<td align='center' ><button className="button" onClick={(e)=>{ lookupblnum(e); }} >search</button></td>
	</tr>
</tbody>
</table>


	<table align='center' className='customers' style={{width:"95%"}} >
	<thead>
	<tr>
		<th>#</th>
		<th>Customer Name</th>
		<th>Customer Type</th>
		<th>Status Card</th>
		<th>Drive License</th>
		<th>NIB #</th>
		<th>Address</th>
		<th>Email</th>
		
	</tr>
	</thead>
	<tbody>
		{tblblinfo}
	</tbody>
	</table>
	


<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button"  >&times;</span>
        <div align='center' id='modalsmtext' >
		<p style={{color:"brown",fontWeight:"bold"}} >Add New Worker/ Modify Existing Worker {watchitem.WATCH_ITEM_ID}</p>
		<p style={{color:"brown"}} >Please be certain to spell the name correctly to help find the person</p>
		
		<form id="form1" method="POST" onSubmit={(e)=>{submitform1(e);}} >
		<table align='center' style={{width:"75%"}} >
		<tbody>
		<tr>
			<td align="right" >Worker's First Name:</td>
			<td align="left" ><input type="text" name="FIRST_NAME" value={watchitem.FIRST_NAME} required placeholder='first name' onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{e.target.select();}} autoComplete="off" /></td>
		</tr>
		<tr>
			<td align="right" >Worker's Last Name:</td>
			<td align="left" ><input type="text" name="LAST_NAME" value={watchitem.LAST_NAME} required placeholder='last name' onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{e.target.select();}} autoComplete="off" /></td>
		</tr>
		<tr>
			<td align="right" >Worker's Gender:</td>
			<td align="left" >
			<select name="GENDER" value={watchitem.GENDER} required onChange={(e)=>{handleChange(e);}} >
			<option value='' ></option>
			<option value='Female' >Female</option>
			<option value='Male' >Male</option>
			</select>
			&nbsp;
			<input type="text" name="PERSON_ID" value={watchitem.PERSON_ID} readOnly className="gnsbro" size="7" onFocus={(e)=>{e.target.select();}} autoComplete="off" />
			</td>
		</tr>
		<tr>
			<td align="right" >Date of Birth:</td>
			<td align="left" ><input type="date" name="DOB" value={watchitem.DOB} required onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{e.target.select();}} autoComplete="off" /></td>
		</tr>
		<tr>
			<td align="right" >Active:</td>
			<td align="left" >
			<select name="ACTIVE" value={watchitem.ACTIVE} required  onChange={(e)=>{handleChange(e);}} >
			<option value='1' >Yes</option>
			<option value='0' >No</option>
			</select>
			</td>
		</tr>
		<tr>
			<td align="right" >Note:</td>
			<td align="left" ><input type="text" name="NOTE" value={watchitem.NOTE} onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{e.target.select();}} autoComplete="off" /></td>
		</tr>
		<tr>
			<td align="right" ><input type="text" name="LBR_CLR_APP_ID" placeholder='Labour Clearance Id #' value={watchitem.LBR_CLR_APP_ID} size="16" onChange={(e)=>{handleChange(e);}} onBlur={(e)=>{getwatchitemlbrclr(e);}} onFocus={(e)=>{e.target.select();}} autoComplete="off" style={{textAlign:"center"}} /></td>
			<td align="left" ><button id="btnsubmit1" className="button" >save changes to watch list</button></td>
		</tr>
		</tbody>
		</table>
		</form>
	
		</div>
    </div>
</div>
<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default Renderwatchitem;